import { Box } from '@pets-ui/Box/Box'
import { type ButtonProps } from '@pets-ui/Button/Button'
import { Button } from '@pets-ui/Button/Button'
import { HStack } from '@pets-ui/HStack/HStack'
import { type InputProps } from '@pets-ui/Input/Input'
import { Input } from '@pets-ui/Input/Input'
import { colors } from '@pets-ui/tokens/colors.stylex'
import * as stylex from '@stylexjs/stylex'
import { type FormEventHandler } from 'react'

const styles = stylex.create({
  whiteBackground: {
    backgroundColor: colors.white,
  },
})

const inputXStyles: InputProps['xStyles'] = {
  inputBase: { root: styles.whiteBackground },
}

export interface CouponManualInputProps {
  onSubmit?: FormEventHandler<HTMLFormElement>
  onChange?: InputProps['onChange']
  disabled?: ButtonProps['disabled']
  value?: InputProps['value']
  placeholder?: InputProps['placeholder']
  submitText?: ButtonProps['children']
  isCouponInputDisabled?: boolean
}

export const CouponManualInput = (props: CouponManualInputProps) => {
  const { onSubmit, onChange, disabled = false, value, placeholder, submitText: submitChildren, isCouponInputDisabled } = props
  return (
    <form onSubmit={onSubmit} style={{ margin: '0' }}>
      <HStack gap={2}>
        <Box flex={1}>
          <Input
            value={value}
            onChange={onChange}
            fullWidth
            placeholder={placeholder}
            disabled={isCouponInputDisabled}
            xStyles={inputXStyles}
          />
        </Box>
        <Button type="submit" variant="outlined" color="blue" disabled={disabled}>{submitChildren}</Button>
      </HStack>
    </form>
  )
}
